import React, { useState, useEffect } from 'react';
import { 
    Button,
    Dialog,  
    DialogActions, 
    DialogContent,  
    DialogContentText, 
    DialogTitle,
    useMediaQuery,
} from '@ellucian/react-design-system/core';
import { useIntl, FormattedMessage } from 'react-intl';
import { Prompt, useHistory, matchPath } from 'react-router-dom';
import PropTypes from 'prop-types';
import useApplicationForm from './useApplicationForm';
import { routes } from '../Helpers/Configuration';
import { useSelector } from 'react-redux';
import { findChangedValues, findChangedStagerValues } from '../Helpers/ApplicationHelpers';
import ApsSaveWarningTable from './ApsSaveWarningTable';
import { useTheme } from '@mui/material';

const selectAllValues = state => state.form.values;
const selectOriginalApplicationValues = state => state.application.originalApplicationValues;

const ApsSaveWarningDialog = (props) => {
    const { handleSaveForm, previewMode, stagerMode, stagerValues, originalStagerValues } = props;
    const intl = useIntl();
    const history = useHistory();
    const values = stagerMode ?  stagerValues : useSelector(selectAllValues);
    const originalValues = stagerMode ? originalStagerValues : useSelector(selectOriginalApplicationValues);
    const [open, setOpen] = useState(false);
    const [lastLocation, setLastLocation] = useState(null);
    const [changes, setChanges] = useState([]);
    const [confirmedNavigation, setConfirmedNavigation] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const {
        template = { pages: [] },
    } = useApplicationForm();
    useEffect(() => {
        if (confirmedNavigation && lastLocation) {
            history.push(lastLocation.pathname);
        }
    }, [confirmedNavigation, lastLocation]);

    const showModal = (location) => {
        setOpen(true);
        setLastLocation(location);
    };

    const handleBlockedNavigation = (nextLocation) => {
        const editMatch = matchPath(nextLocation.pathname, {
            path: [
                routes.importsApplicationEditPage,
                routes.importsStagersRecord
            ]
        });
        let changedValueArray = [];
        if (!editMatch && !previewMode && !confirmedNavigation) {
            changedValueArray = stagerMode ? findChangedStagerValues(originalValues, values) : findChangedValues(originalValues, values, template, intl.locale);
            setChanges(changedValueArray);
        }        
        if (!confirmedNavigation && !!changedValueArray?.length && !editMatch){
            showModal(nextLocation);
            return false;
        }
        return true;
    };

    const handleSave = () => {
        setConfirmedNavigation(true);
        setOpen(false);
        handleSaveForm('save');  
    };

    const handleDiscard = () => {
        setConfirmedNavigation(true);
        setOpen(false);
    };

    const handleCancel = () => {
        setOpen(false);
    };
 
    return (
        <div>
            <Prompt when={true} message={handleBlockedNavigation}/>
            <Dialog
                open={open}
                onClose={handleCancel}
                fullScreen={isMobile}
                maxWidth="lg"
                fullWidth
            >
                <DialogTitle>
                    <FormattedMessage id="applicationProcessingSaveWarningTitle"/>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <FormattedMessage id="applicationProcessingSaveWarningContent"/>
                    </DialogContentText>
                    {!!changes?.length &&
                        <ApsSaveWarningTable changes={changes} stagerMode={stagerMode}/>
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDiscard} color="secondary">
                        <FormattedMessage id="appDesignConfigurationSaveModalDiscard"/>
                    </Button>
                    <Button onClick={handleCancel} color="secondary">
                        <FormattedMessage id="appDesignConfigurationSaveModalCancel"/>
                    </Button>
                    <Button onClick={handleSave} color="primary" id="save">
                        <FormattedMessage id="appDesignConfigurationSaveModalSave"/>
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

ApsSaveWarningDialog.propTypes = {
    handleSaveForm: PropTypes.func.isRequired,
    previewMode: PropTypes.bool.isRequired,
    stagerMode: PropTypes.bool,
    stagerValues: PropTypes.array,
    originalStagerValues: PropTypes.array

};

export default ApsSaveWarningDialog;